<template>
  <div>
    <section class="hero">
      <div class="hero-inner">
        <div>
          <div class="hero-kicker">{{ t('heroKicker') }}</div>
          <h1>{{ brandName }}</h1>
          <p>{{ welcome || statement }}</p>
          <div class="hero-actions">
            <router-link class="btn btn-primary" to="/submit">{{ t('heroCtaSubmit') }}</router-link>
            <router-link class="btn btn-ghost" to="/policy">{{ t('heroCtaPolicy') }}</router-link>
          </div>
        </div>
        <div class="hero-art" aria-hidden="true">
          <svg viewBox="0 0 420 280" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="70" y="36" width="280" height="188" rx="18" fill="#0f1720" stroke="#3b82f6" stroke-width="3"/>
            <rect x="92" y="58" width="236" height="132" rx="8" fill="#142033"/>
            <circle cx="128" cy="96" r="18" fill="#1a8cff"/>
            <rect x="160" y="82" width="140" height="10" rx="5" fill="#94a3b8"/>
            <rect x="160" y="102" width="108" height="8" rx="4" fill="#64748b"/>
            <rect x="108" y="140" width="204" height="28" rx="8" fill="#1e3a5f"/>
            <rect x="186" y="228" width="48" height="10" rx="5" fill="#334155"/>
          </svg>
        </div>
      </div>
    </section>
    <section class="home-process">
      <h2>{{ t('processTitle') }}</h2>
      <process-steps :steps="processSteps" />
    </section>
    <section class="cards">
      <div class="card">
        <h3>{{ t('navPolicy') }}</h3>
        <p>{{ t('homeCardPolicy') }}</p>
        <router-link class="btn btn-outline" to="/policy">{{ t('navPolicy') }}</router-link>
      </div>
      <div class="card">
        <h3>{{ t('navSubmit') }}</h3>
        <p>{{ t('homeCardSubmit') }}</p>
        <router-link class="btn btn-primary" to="/submit">{{ t('navSubmit') }}</router-link>
      </div>
      <div class="card">
        <h3>{{ t('navAdvisories') }}</h3>
        <p>{{ t('homeCardAdvisories') }}</p>
        <router-link class="btn btn-outline" to="/advisories">{{ t('navAdvisories') }}</router-link>
      </div>
    </section>
  </div>
</template>
<script>
import { t } from '../i18n'
import { mapState, mapGetters } from 'vuex'
import ProcessSteps from '../components/ProcessSteps.vue'

export default {
  name: 'Home',
  components: { ProcessSteps },
  computed: {
    ...mapState(['locale', 'brand']),
    ...mapGetters(['brandName', 'welcome', 'statement', 'processSteps'])
  },
  methods: {
    t(key) {
      return t(this.locale, key)
    }
  }
}
</script>
